import { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button,
  Box,
  Stack,
} from "@mui/material";

export default function CookiePopup() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("cookieConsent");
    if (!consent) {
      setOpen(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem("cookieConsent", "accepted");
    setOpen(false);
  };

  const handleDecline = () => {
    localStorage.setItem("cookieConsent", "declined");
    setOpen(false);
  };

  return (
    <Dialog
      open={open}
      fullWidth
      maxWidth="sm"
      PaperProps={{
        sx: {
          borderRadius: 3,
          p: 2,
        },
      }}
    >
      <DialogTitle>
        🍪 Gestion des cookies
      </DialogTitle>

      <DialogContent>
        <Typography variant="body1" gutterBottom>
          Nous utilisons des cookies essentiels pour sécuriser vos paiements et améliorer votre expérience utilisateur.
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Vous pouvez choisir d’accepter ou de refuser les cookies non essentiels. 
          Les cookies nécessaires au bon fonctionnement du site sont toujours activés.
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
          <a href="https://www.alceeavocats.com/politique-de-cookies/" target="_blank" rel="noopener noreferrer">
            En savoir plus sur notre politique de cookies
          </a>
        </Typography>
      </DialogContent>

      <DialogActions>
        <Box sx={{ width: "100%" }}>
          <Stack direction="row" spacing={2} justifyContent="flex-end">
            <Button
              variant="outlined"
              color="error"
              onClick={handleDecline}
            >
              Je refuse
            </Button>
            <Button
              variant="contained"
              
              onClick={handleAccept}
            >
              J’accepte
            </Button>
          </Stack>
        </Box>
      </DialogActions>
    </Dialog>
  );
}
